export const COLOR_YELLOW = 2;
export const COLOR_CYAAN = 3; // blue
export const COLOR_TURQUOISE = 4; // darker blue
